/*
 * @Author: Claude Code
 * @Date: 2026-03-03
 * @Description: Avatar Video 功能卡片组件
 */
import { useRouter } from 'next/router';
import { memo } from 'react';

import { useRouteChange } from '@/hooks/useRouteChange';
import { useTranslate } from '@/hooks/useTranslate';
import { ROUTE_FROM } from '@/utils/const';
import { PageVisitFrom } from '@/utils/eventlog/eventNewConfig';
import { avatarVideoProURL } from '@/utils/router';

import { HOME_FEATURE_VIDEOS } from '../../constants';

const AvatarVideoCard = memo(() => {
  const { t } = useTranslate();
  const { navigate } = useRouteChange();
  const router = useRouter();

  const handleClick = () => {
    sessionStorage.setItem(ROUTE_FROM, PageVisitFrom.HOME_CLICK);
    navigate(() => {
      router.replace(avatarVideoProURL);
    });
  };

  return (
    <div
      className="relative flex flex-1 flex-col h-[242px] rounded-[8px] overflow-hidden cursor-pointer hover:translate-y-[-4px] transition-all"
      onClick={handleClick}
    >
      {/* 视频铺满整张卡片 */}
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        className="absolute inset-0 w-full h-full object-cover"
        src={HOME_FEATURE_VIDEOS.AVATAR_VIDEO}
      />

      {/* 文字信息区域 - 叠加在视频上方 */}
      <div className="relative z-10 mt-auto flex flex-col gap-[4px] px-[12px] py-[8px] backdrop-blur-[10px] bg-[rgba(0,0,0,0.2)]">
        <div className="text-[20px] font-bold text-white leading-[28px]">
          {t('bc.AvatarVideoPro')}
        </div>
        <div className="text-[12px] text-[rgba(255,255,255,0.8)] leading-[18px]">
          {t('e47101b2eadcba224fff5aef6688a3b7')}
        </div>
      </div>
    </div>
  );
});

AvatarVideoCard.displayName = 'AvatarVideoCard';

export default AvatarVideoCard;
